import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
import calendar from "../../../../../../assets/images/meetupEvent/calendar.png";
import Clock from "../../../../../../assets/images/meetupEvent/clock-icon.png";
import "./ConfirmOrEditAuction.css";

const ConfirmOrEditAuction = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  let history = useHistory();

  function handleClick() {
    // history.push('/superstar-admin/souvenir/live-biddings');
    history.push("/superstar-admin/auction/product-list/pending");
  }

  function editProduct() {
    history.push(`/superstar-admin/edit-auction/${auctionConfirm.id}`);
  }

  const [auctionConfirm, setConfirmation] = useState([]);

  useEffect(() => {
    axios.get(`/api/admin/editOrConfirm/auction/editOrConfirm`).then((res) => {
      if (res.status === 200) {
        setConfirmation(res.data.product);
      }
    });
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-8 mb-3">
          <div className="card card-bg p-2">
            <img
              className="w-100 img-fluid"
              src={imageCdnUrl + auctionConfirm.banner}
              alt=""
              style={{ height: "280px" }}
            />
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="card card-bg p-2">
            <img
              src={imageCdnUrl + auctionConfirm.product_image}
              alt="Pineapple"
              className="img-fluid Cricket-Img w-100"
              style={{ height: "280px" }}
            />
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-12">
          <div className="card card-bg shadow">
            <div className="card-body">
              <h5 className="text-light pb-3">{auctionConfirm.name}</h5>

              <h5 className="text-light pb-3">{auctionConfirm.title}</h5>

              <h5 className="text-warning">Description</h5>
              <div className="under-line"></div>
              <p className="text-light mt-2">
                <Markup content={auctionConfirm.details} />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className=" row mt-3 mb-5 cricket-jersey">
        <div className="col-sm-12 col-md-4 col-lg-3 mb-3">
          <div className="card-bg p-2 d-flex col-12">
            <div className="mt-2  mx-3 ">
              <span className="text-light">
                {" "}
                <img src={calendar} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1">
              <span className="text-light">Last Date</span>
              <br></br>
              <span className="text-warning   ">
                {moment(auctionConfirm.bid_to).format("LL")}
              </span>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4 col-lg-3 mb-3">
          <div className="card-bg p-2 d-flex col-12">
            <div className=" mt-2 mx-3">
              <span className="text-light">
                {" "}
                <img src={Clock} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1 ">
              <span className="text-light">Time</span>
              <br></br>
              <span className="text-warning   ">
                {moment(auctionConfirm.bid_to).format("LT")}
              </span>
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-4 col-lg-3 mb-3">
          <div className="card-bg p-2 d-flex col-12">
            <div className="mt-2  mx-3 ">
              <span className="text-light">
                {" "}
                <img src={calendar} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1">
              <span className="text-light">Result Published</span>
              <br></br>
              <span className="text-warning   ">
                {moment(auctionConfirm.result_date).format("LL")}
              </span>
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-4 col-lg-3 mb-3">
          <div className="card-bg p-2 d-flex col-12">
            {" "}
            <div className="mt-2  mx-3 ">
              <span className="text-light">
                {" "}
                <img src={calendar} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1">
              <span className="text-light">Product Delivery</span>
              <br></br>
              <span className="text-warning  ">
                {moment(auctionConfirm.product_delivery_date).format("LL")}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-12 mb-5">
          <div className="row">
            <div className="col-md-6 row mx-auto">
              <div className="col-md-6 my-1 mx-auto">
                <button
                  onClick={handleClick}
                  className="btn btnConfirm w-100 fw-bold"
                >
                  Forward to superstar
                </button>
              </div>
              <div className="col-md-6 my-1 mx-auto">
                <button
                  onClick={editProduct}
                  className="btn btnEditTest w-100 mx-md-2 fw-bold"
                >
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmOrEditAuction;
